import { CrossSellingRankingNode } from "components/Transactional/CrossSelling/interfaces"
import { IntlShape, useIntl } from "react-intl"
import { CHILEAN_CURRENCY } from "helpers/numbers"

const parseFormat = (value: number, intl: IntlShape, decimals: number = 2) =>
	intl.formatNumber(value, {
		maximumFractionDigits: decimals,
	})

const useGetFormattedRanking = (data: CrossSellingRankingNode[]) => {
	const intl = useIntl()
	return data.map((r) => ({
		ranking: r.ranking,
		focus: r.focus,
		nonFocus: r.nonFocus,
		focusConfidence: `${parseFormat(r.focusConfidence * 100, intl)}%`,
		noFocusConfidence: `${parseFormat(r.noFocusConfidence * 100, intl)}%`,
		trxFocus: intl.formatNumber(r.trxFocus),
		trxNonFocus: intl.formatNumber(r.trxNonFocus),
		trxCross: intl.formatNumber(r.trxCross),
		itemsFocus: intl.formatNumber(r.itemsFocus),
		itemsNoFocus: intl.formatNumber(r.itemsNoFocus),
		itemsCross: intl.formatNumber(r.itemsCross),
		avgSpendFocus: `${parseFormat(
			r.avgSpendFocus,
			intl,
			0
		)} ${CHILEAN_CURRENCY}`,
		avgSpendNoFocus: `${parseFormat(
			r.avgSpendNoFocus,
			intl,
			0
		)} ${CHILEAN_CURRENCY}`,
	}))
}

export default useGetFormattedRanking
